import React from 'react'
import PropTypes from 'prop-types'
import { Modal, ModalHeader, ModalBody } from 'reactstrap'
import { FormattedMessage } from 'react-intl'
import Login from '../../../containers/Login/Login'
import './LoginModal.scss'

const LoginModal = ({ isOpen, toggle }) => {
  // Generate unique IDs for accessibility
  const modalId = 'loginModal'
  const modalTitleId = 'login-modal-title'

  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      id={modalId}
      size="lg"
      centered
      aria-labelledby={modalTitleId}
      role="dialog"
    >
      <ModalHeader toggle={toggle}>
        <span className="sr-only">
          <FormattedMessage id="global.label.close" defaultMessage="Close" />
        </span>
      </ModalHeader>
      <ModalBody>
        <h2 id={modalTitleId} className="sr-only">
          <FormattedMessage id="global.label.login" defaultMessage="Log In" />
        </h2>
        <div className="row">
          <div className="col">
            <Login isModal />
          </div>
        </div>
      </ModalBody>
    </Modal>
  )
}

LoginModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
}

export default LoginModal
